import { useState, useEffect, useCallback } from 'react';
import { getTournaments } from '@/api/TournamentManagement/tournamentApi';
import type { TournamentListView, TournamentListQuery } from '@/models/tournament';

export function useTournaments(query: TournamentListQuery) {
  const [data, setData] = useState<TournamentListView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getTournaments(query);
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, [query.search, query.status, query.startDateFrom, query.startDateTo, query.sortBy, query.sortDescending, query.page, query.pageSize]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
